<template>
    <div class="app">

        <Header></Header>

      <div class="mid" style="padding-top: 0px;">
        <div class="userProtocol ">
          <div class="bg-color problem">
              <router-link to="/xieyi">《用户服务协议》</router-link>
              <a  style="padding-bottom: 15px;border-bottom: 2px solid #008DF2;color: #008DF2">《隐私政策》</a>
              <router-link to="/guifan">《链接内容管理规范》</router-link>
             <router-link to="/help">《使用帮助》</router-link>
            </div>
            <div class="box-center">
              <div class="word_area">
                <div >
                  <h1>隐私政策</h1>
                  <ol><li>本隐私政策描述了天天集团（以下简称“天天集团”）在您使用ttdwz.cc（以下简称“本网站”）以及ttdwz.cc所提供的服务、功能、内容或应用程序时对您的相关信息的收集、使用和披露的政策和程序。</li></ol>
                  <h3>
                    本网站可能通过以下途径获取您的信息：</h3>
                  <ol>
                    <li>
                      1. 当您注册本网站和服务时通过您在本网站的用户账户获取；</li>
                    <li>
                      2. 当您使用服务时；</li>
                    <li>
                      3. 通过第三方网站和服务获取，包括天天集团拥有的其他的应用和服务。</li>
                    <li>
                      您使用我们的服务即意味着您同意我们收集、传输、存储、披露您的信息以及将您的信息用作本《隐私政策》中描述的其他用途。您所提供的信息将可能被我们在中国或者其他国家传输、处理和访问。                        </li>
                  </ol>
                  <h3>本《隐私政策》包含哪些内容？</h3>
                  <ol>
                    <li> 本《隐私政策》涵盖了对于您使用我们服务时本网站所收集的信息的处理，也涵盖了对于本网站商业伙伴或者天天集团其他的应用和服务分享的您的信息的处理。</li>
                    <li>
                      本《隐私政策》不适用于不属于天天集团拥有和控制的其他企业的做法，包括您能通过本网站访问的其他公司的网站、服务和应用（第三方服务）。虽然我们只选择与那些认同我们对您隐私的尊重的第三方服务合作，但是我们不能对这些第三方服务的内容和隐私政策负责。因此，我们建议您去查看您所访问的第三方服务的隐私政策。
                    </li>
                  </ol>
                  <h3>ttdwz.cc收集哪些信息以及我们如何使用这些信息？</h3>
                  <ol>
                    <li>我们收集的这些信息主要是用于提供服务、处理和完成交易、响应查询、个性化和改善服务、监控和分析使用情况和服务趋势，为您提供相关的信息等。在服务相关的某些方面,我们会要求收集或显示一些您的信息。我们收集用户以下信息:</li>
                    <li>
                      用户信息：
                    </li>
                    <li >当您创建账户时，我们会收集您的个人信息，例如您的姓名和电子邮件地址。如果您使用已经登录的其他账户来在本网站创建账户，我们会访问和收集您在那个账户中所提供的个人信息（基于您的隐私设置）。我们可能使用您的联系信息来向您发送我们的服务信息，您可以通过账户设置来取消订阅此类消息，但必要时本网站和天天集团保留联系您的权利，比如出于行政和账户管理的目的。</li>
                    <li >关于未成年人使用我们的服务:</li>
                    <li>
                      我们不会有意收集未成年人的个人信息。如果我们了解到我们收集了18岁以下未成年人的个人信息,我们将采取必要的步骤来从我们的系统通知中删除这些信息。                        </li>
                  </ol>
                  <h3>网址（URL）信息：</h3>
                  <ol>
                    <li>
                      ttdwz.cc服务的一个特点是创建缩短的网址（URL）的能力。本网站同时收集和存储原始URL和被缩短后的URL，如果您登录到您的账户，我们会将信息关联到您的账户。本网站也收集和存储您缩短原始URL的时间和日期，当您分享链接时，网络信息也将同时被分享。                        </li>
                  </ol>
                  <h3>指标和分析</h3>
                  <ol>
                    <li>ttdwz.cc收集由本网站服务所创建的每一个链接的访问（例如点击）信息。这里的信息包括但不仅限于：</li>
                    <li>访问链接的设备的IP地址和实际位置；</li>
                    <li>相关的网址和设备；</li>
                    <li>每次访问的时间和日期；</li>
                    <li>链接在第三方服务分享的信息。</li>
                    <li>这些指标和信息将被用于本网站及本网站合作伙伴提高服务质量，例如提供增值功能等。</li>
                  </ol>
                  <h3>用户内容：</h3>
                  <ol>
                    <li>
                      本服务的某些功能允许您提供一些内容服务，比如URL的书面描述、评论、图片和视频等。您向服务器提交的所有内容都会被本网站保留,即使在您注销了账户以后这些内容也可能被第三方按照本《隐私政策》中的描述进行分享。
                    </li>
                  </ol>
                  <h3>从第三方服务收集的信息：</h3>
                  <ol>
                    <li>本服务的某些功能允许您通过您的账户和其他公司共享您的内容和链接。如果您选择将本网站和第三方服务相连接，我们会收集与您使用第三方服务相关的信息，例如身份验证令牌，这使我们能够连接您的第三方服务帐户或者您朋友们的联系方式（如果您选择了联系您的朋友、粉丝或者您账户中的联系方式），这样当您使用服务时您可以联系这些人。我们也会收集有关您如何使用本服务来与连接的第三方服务交互的信息。需要注意的是，基于您账户的隐私设置第三方服务可能具有限制提供给我们信息的能力。</li>
                  </ol>
                  <h3>自动收集的信息：</h3>
                  <ol>
                    <li>ttdwz.cc会自动接收并记录您的浏览器和服务器日志上的信息，其中包括您的 IP 地址、浏览器类型、一般位置和 cookie信息。这些信息将用于帮助我们理解用户如何传播网站,用来打击垃圾邮件/恶意软件,促进有关您与服务交互数据的集合以及其他相似的用途。</li>
                    <li>当您访问服务时ttdwz.cc也会自动接收和记录您的移动设备传输信息，例如设备标识符、设备设置和操作系统。这些信息是用来促进您的访问以及提高对本服务的使用频率,访问和使用其他第三方服务以及其他相似的用途。</li>
                    <li>一般情况下，服务器会自动收集使用信息，例如网站访客的数量和频率信息。本网站可以集合形式使用这些数据，也就是说，作为统计的措施，但不是以识别您个人的方式。这种类型的汇总数据使我们和我们授权的第三方了解到个人使用部分服务的频次，使得我们可以分析和改进服务。</li>
                    <li>当您访问网站时，我们会收集您的一般位置信息（例如您的城市和国家，这来自于您的IP地址）。当您通过移动设备访问和使用服务时，我们可以使用各种技术来确定您的位置(如果您启用了这个功能)。</li>
                    <li>
                      当您打开我们发送的邮件时我们会收到确认，我们以此来提升客户服务。</li>
                  </ol>
                  <h3>Cookie 政策</h3>
                  <ol>
                    <li>Cookie是当您访问一个网站时，通过Web浏览器提供给您的计算机的文本片段。您的浏览器以您访问的每个网站相关联的方式存储cookie。我们使用cookie使我们的服务器识别出您的Web浏览器，并告诉我们您访问我们网站和通过网络使用服务的方式和时间。</li>
                    <li>ttdwz.cc的cookie也使得本网站可以在您点击一个短链接时进行跟踪。短链接的每一次点击都使用分配给您的，存储在与本网站相关的web浏览器上的一个或多个cookie上的唯一标识符进行跟踪。</li>
                    <li>本网站的cookie不包含任何关于您的个人信息,我们不把通过cookie收集的一般信息和您的个人信息相结合来确定您的身份。然而,我们使用cookie来识别出您的web浏览器访问了本网站的链接,同时如果您拥有本网站的账户，则可以将这些信息与您的账户相关联。
                    </li>
                    <li>大多数浏览器有一个关掉cookie功能的选项,这将阻止您的浏览器接受新cookie,以及允许您决定以多种方式接受新cookie(取决于您的浏览器软件的复杂性)。如果您禁用cookie,您将不能使用大多数的特色服务。本网站的cookie被设置成一个月后自动失效。</li>
                    <li>您可能也会要求本网站不要在您的web浏览器上放置cookie。当cookie以这种方式被禁用，点击本网站的链接将不会绑回或与您的web浏览器相关联。
                    </li>
                    <li>本《隐私政策》只涵盖本网站cooike的使用，不包含任何第三方服务对与cookie的使用。本网站不控制第三方在您的电脑上放置cookie的时间和方式，例如当您从本网站的链接访问一个网址时。</li>
                    <li>如果您是天天集团的多个应用程序和服务的用户,我们可以将本网站的cookie与那些应用程序和服务的cookie相结合，以此为您提供单点登录服务。这是为了使您更容易地访问多个服务，同时限制了每一次当您注册我们的服务时所需要提供的信息量。此外,它会为您提供相关的内容或信息,并协助本网站的行政和账户管理功能。
                    </li>
                  </ol>
                  <h3>什么是信息共享？</h3>
                  <ol>
                    <li>本服务旨在帮助您和其他人分享信息。因此，大部分通过服务生成的信息是被公开或与第三方共享的。</li>
                  </ol>
                  <h3>链接和使用信息：</h3>
                  <ol>
                    <li>您在本服务上的大部分活动默认是公开的，这包括但不仅限于：</li>
                    <li>
                      1. 您所缩短的原始URL，它们相应的短链接，缩短URL的时间和日期，您的链接的指标和分析信息，如上所述；
                    </li>
                    <li>2. 关于您点击的链接的非个人信息集合和与之相关的指标和分析信息，如上所述；</li>
                    <li>3．您创建的每一个自定义链接和相关内容（如果您选择让这些内容公开）。</li>
                    <li>
                      注册用户会有一些与他们的帐户相关的信息。未注册的用户将不会有此关联，但有关其使用服务的信息（他们点击了什么链接，点击的时间，点击的地址等）将会被存储在本网站上的cookie进行匿名跟踪。
                    </li>
                    <li>本网站的链接和普通使用服务可能会以匿名或者集合形式（即非个人身份）与我们的客户和商业伙伴分享。比如通过服务与URL的所有者或者其他天天集团的应用程序和服务实现共享。这些信息使我们能够更好地了解到用户如何使用我们的产品和服务以及其他的产品和服务，了解用户的兴趣以及我们的服务如何与他们的服务进行互操作，产品开发，市场营销优化和研究，并提高通过服务所展示的在线广告和营销的相关性（或使其符合您的利益）。
                    </li>
                    <li>请谨记如果您选择提供关于您使用特定功能的服务信息，这些信息将受该特定功能的隐私设置所管理，从而可以被其他人公开访问。</li>
                    <li>IP地址信息：</li>
                    <li>我们收集和存储IP地址信息但这些信息是非公开的。我们有时与我们的合作伙伴、服务提供商以及与我们开展业务的其他公司分享IP地址信息，但大多数情况下，当我们和第三方分享IP地址信息时，我们会使用加密打乱的IP地址，从而使其不能有效逆转成实际的IP地址或单独链接到您。</li>
                  </ol>
                  <h3>您选择分享的信息：</h3>
                  <ol>
                    <li>
                      创建一个链接后您可以通过第三方服务分享这个链接。您选择通过第三方服务来分发的信息也将会提供给他们，之后第三方服务的用户也可以访问这些信息。您也可以通过本服务访问其他的第三方服务，如点击统计页面的链接。由于本网站对于第三方服务的隐私政策不控制、不负责，因此建议您阅读您通过我们的服务所访问的第三方服务的《服务协议》和《隐私政策》。                        </li>
                  </ol>
                  <h3>用户配置文件信息：</h3>
                  <ol>
                    <li>
                      用户配置文件信息包括用户名和邮箱、手机号（您的账户已与这些服务相联），同时您输入的其他信息也会显示给其他用户以促进服务中的用户交互。但用户的电子邮件地址不会通过本网站直接透露给其他用户。</li>
                  </ol>
                  <h3>与本网站服务供应商的信息分享：</h3>
                  <ol>
                    <li>我们将代表本网站和我们的服务供应商与个人或其他实体以雇佣和合同的方式来完成特定的任务。为了给您提供产品和服务，我们需要和我们的服务供应商分享您的信息。除非我们另行通知您，否则我们的服务供应商没有任何超过为我们提供服务的目的而使用我们分享给他们的您的信息的权利。
                    </li>
                  </ol>
                  <h3>根据业务转让披露的信息：</h3>
                  <ol>
                    <li>用户的信息在我们出售公司资产或其他情况下有可能会作为我们企业资产之一而被转让。在这种情况下，本网站的收购方可以继续根据本政策使用您的信息。</li>
                  </ol>
                  <h3>
                    出于保护本网站及其他目的而披露的信息：</h3>
                  <ol>
                    <li>本网站保留在必要时访问、读取、储存和披露任何信息的权利：</li>
                    <li>1. 遵守所有适用法律、法规，应法律程序或政府要求；</li>
                    <li>2．执行这些服务条款，包括对潜在违规行为展开调查；</li>
                    <li>3. 检测，防止或解决欺诈，安全或技术问题;</li>
                    <li>4．响应用户支持请求。</li>
                    <li>5．保护本网站用户和公众的权利、财产和安全。这包括与其他公司和组织为防止欺诈和垃圾邮件/恶意软件防范交换信息。</li>
                  </ol>
                  <h3>根据您的同意我们分享的信息：</h3>
                  <ol>
                    <li>我们会在下列情况下分享您的信息：</li>
                    <li>当您和其他人分享本网站的链接和内容时；我们告知您,您提供的信息将会以一种特定的方式被分享时；您在第三方服务分享或发布信息时。</li>
                  </ol>
                  <h3>我的信息是怎样被保护的？</h3>
                  <ol>
                    <li>
                      您的账户信息通过您的密码来保护您的隐私和安全。您可以适当的选择和保护您的密码来阻止非法访问，同时您也可以通过在您完成对账户访问后退出登录来限制对于您的计算机和浏览器的访问。
                    </li>
                  </ol>
                  <h3>
                    我有什么选择,我可以访问我的什么信息?</h3>
                  <ol>
                    <li>
                      您不需要一个帐户就可以创建短链接,在没注册的情况下您可以使用许多服务的功能，从而限制了被单独收集的有关您的信息。                        </li>
                    <li>如果您是一个注册用户，您可以通过登录网站来访问和您账户有关的信息。这些信息包括您缩短的URL历史记录，和这些URL指标页面的访问记录。您可以在账户设置页面随时停用您的账户。如果您关闭了您的账户，您将不能再访问和使用本服务。</li>
                    <li>
                      请注意，为了确保现有的链接继续为我们的用户服务，您创建和分享的短链接不能被删除或失效（即使您的账户已停用），同时您账户的每一次缩短和分享活动也不能被删除。如果您对此有疑问请联系：pacci5566@gmail.com。</li>
                  </ol>
                  <h3>
                    在本《隐私政策》变更后怎么办?</h3>
                  <ol>
                    <li>本网站可能适时修订本《隐私政策》的条款，如果我们在收集和使用信息的方式上发生重大的改变，我们会通过发布公告或给您发送电子邮件的方式来通知您，同时我们也将在通知中写明修订后的《隐私政策》生效的时间。在该种情况下，若您继续使用我们的服务，即表示同意受修订后的《隐私政策》的约束。</li>
                  </ol>
                  <h3>
                    在阅读完本政策之后，如您对本《隐私政策》或与本《隐私政策》相关的事宜有任何问题，请与pacci5566@gmail.com联系。</h3>
                </div>
              </div>
            </div>


          </div>

        </div>
      <div class="box gray-back">
        <div class="copyright gray-back">
          <div>
            <span><a href="/">常见问题</a></span>
            <span><a href="/userProtocol"target="_blank">用户协议</a></span>
            <span><a href="/privacyPolicy" target="_blank">隐私政策</a></span>
            <span><a href="/guifan" target="_blank">内容管理规范</a></span>
          </div>
          <div>Copyright © 2015-2019  版权所有</div>
        </div>
      </div>

    </div>
</template>

<script>
    import Header from "../header";
    export default {
        name: "Help",
      components: {Header},
      data() {
            return {
                demoCodeTabs: 1,
                isVip: false,
                isGuest: true,
                user_info: {},
            }
        },
        mounted() {
            const token = this.$storeLocal.get('token');
            const user_info = this.$storeLocal.get('userInfo');
            const times = Date.parse(new Date())/1000;

            if (token !== null && token !== '' && token !== undefined) {
                if (user_info.expire_date > times){
                    this.isVip = true;
                }
                this.isGuest = false;
                this.user_info = user_info;
            }

        },
      methods:{

      }
    }
</script>

<style scoped>
table{border-spacing:0}
.app{height:auto;background-color:#ffffff}
.mid{width:1200px;height:auto;margin:0 auto;padding-top:20px}
.mid h2.title{border-left:4px solid #008bff;height:20px;line-height:20px;padding-left:5px;margin:10px 0 20px 0;font-size:22px;font-weight:500}

.text-left{text-align:left}
.footer{color:#666666;text-align:center;line-height:114px}
.copyright{padding:40px;line-height: 200%;}
.copyright a{color:#000;display: inline-block;margin-right: 10px;}


</style>
